<script lang="ts">
    import type {ErroredFieldResponse} from 'src/typings';
    import {KpPopoverPanel, type TogglePopoverFn} from 'shared/ui-widgets/popover';
    import {exists, uuid} from 'shared/utils/custom-utils';
    import {createFloatingActions} from 'svelte-floating-ui';
    import {floatingUiCommonSettings} from 'shared/utils/floating-ui-common-settings';
    import {slide} from 'svelte/transition';
    import UIcon from 'shared/ui-widgets/uicons/UIcon.svelte';
    import KpIconButton from 'shared/ui-widgets/button/KpIconButton.svelte';
    import KpMarkdown from 'shared/components/kp-markdown/KpMarkdown.svelte';

    export let error: ErroredFieldResponse;

    const popoverId = uuid();
    const [floatingRef, floatingContent] = createFloatingActions(floatingUiCommonSettings('bottom-end'));

    let togglePopoverFn: TogglePopoverFn;

    let hoverOpened = false;
    let clickOpened = false;
    $: if (exists(togglePopoverFn)) togglePopoverFn(hoverOpened || clickOpened);

    const handleErrorClick = () => {
        clickOpened = !clickOpened;
    };

    const handleHover = () => {
        hoverOpened = true;
    };

    const handleHoverLeave = () => {
        hoverOpened = false;
    };
</script>

<button class="error-icon-button"
        class:click-opened={clickOpened}
        use:floatingRef
        on:click={handleErrorClick}
        on:mouseenter={handleHover}
        on:mouseleave={handleHoverLeave}>

    <UIcon icon="exclamation" lineHeight="1"/>
</button>

<KpPopoverPanel id={popoverId}
                popoverMode="manual"
                additionalClasses="error-field-value-container"
                bind:togglePopover={togglePopoverFn}
                use={[floatingContent]}>

    {#if clickOpened}
        <div class="close-button-container" transition:slide={{axis: 'y', duration: 250}}>
            <KpIconButton buttonStyle="no-background" icon="cross-circle" on:click={() => clickOpened = false}/>
        </div>
    {/if}

    <KpMarkdown markdown={error.text} block/>
</KpPopoverPanel>

<style lang="less">
    @import (reference) "styles/portaro.variables.less";
    @import (reference) "styles/portaro.themes.less";

    @btn-size: 22px;

    .error-icon-button {
        outline: none;
        border: none;
        background: none;
        cursor: pointer;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        font-size: @font-size-default;
        width: @btn-size;
        height: @btn-size;
        border-radius: @border-radius-default;
        color: var(--danger-red);
        transition: background-color 0.3s ease-in-out;

        &:hover {
            background-color: @themed-body-bg-red-highlighted;
        }

        &.click-opened {
            background-color: var(--danger-red);
            color: white;
        }
    }

    .close-button-container {
        display: flex;
        justify-content: end;
        padding-bottom: @spacing-sm;
    }

    :global {
        .error-field-value-container {
            ul ul {
                margin-left: @spacing-ml;
                padding-left: @spacing-m;
                border-left: 1px solid var(--accent-blue);
            }
        }
    }
</style>